module.exports = __webpack_public_path__ + "static/cdp-1-1f0a588b07d8668e870d1948931a1299.svg";